// src/app/models/element.model.ts

export interface UserModel {
  id?: string;
  username: string;
  email: string;
  roles: string | string[];
  password?: string;
  role?: string;
}

export class User implements UserModel {
  id: string = "";
  username: string = "";
  email: string = "";
  password?: string;
  roles: string = '';
  role?: string;
}
